export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_CURRENT_SERVICE = 'SET_CURRENT_SERVICE';
export const SET_ALL_COUNTRIES_LIST = 'SET_ALL_COUNTRIES_LIST';
export const SET_DEFAULT_COUNTRIES_LIST = 'SET_DEFAULT_COUNTRIES_LIST';
export const SET_ALL_TYPE_SERVICES_LIST = 'SET_ALL_TYPE_SERVICES_LIST';
